<template>
  <div class="cart-list">
    <div class="cart-list__row cart-row" v-for="item in cart.items" :key="item.pk">
      <div class="cart-row__title">
        {{ item.title }}
      </div>
      <div class="cart-row__params row-params">
        <div class="cart-row__unit-price cart-price">
          <span class="cart-price__value" v-if="item.unit_price">{{ item.unit_price_render }} р.</span>
          <span class="cart-price__empty" v-if="!item.unit_price"></span>
        </div>
        <div class="cart-row__quiantity cart-quantity">
          <button class="cart-quantity__btn cart-quantity__btn--left" v-on:click="deleteCountFromCart(item, 1)">-</button>
          <input class="cart-quantity__input" type="text" min="1" v-model:number="item.quantity" v-on:input="saveCartItem(item)">
          <button class="cart-quantity__btn cart-quantity__btn--right" v-on:click="addCountToCartCart(item, 1)">+</button>
        </div>
        <div class="cart-row__total-price cart-price">
          <span class="cart-price__value" v-if="item.total_price">{{ item.total_price_render }} р.</span>
          <span class="cart-price__empty" v-if="!item.total_price">запрос цены</span>
        </div>
        <div class="cart-row__delete">
          <button class="cart-row__delete-btn" v-on:click="removeFromCart(item)">✖</button>
        </div>
      </div>
    </div>
    <div class="cart-list__total total-cart">
      <a class="btn btn-primary total-cart__btn" href="/cart/check/">Оформить заказ</a>
    </div>
  </div>
</template>

<script>
import CartMixin from '../vue_mixins/CartMixin.vue'

export default {
  name: 'CartPage',
  mixins: [CartMixin]
}
</script>

<style lang="scss">
</style>
